const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillrule: "evenodd",
      fill: "rgba(25, 118, 210, 1)",
      fillOpacity: 1
    },
    d: "M 12.386719 3.25 C 12.777344 3.625 12.785156 4.234375 12.402344 4.605469 L 12.195312 4.804688 L 13.863281 6.375 L 9.652344 10.269531 L 8.03125 8.65625 L 1.710938 14.726562 C 1.328125 15.09375 0.691406 15.085938 0.300781 14.710938 C -0.09375 14.332031 -0.101562 13.722656 0.28125 13.355469 L 6.625 7.261719 L 5.355469 5.996094 L 9.335938 2.097656 L 10.761719 3.441406 L 10.976562 3.230469 C 11.359375 2.867188 11.992188 2.871094 12.386719 3.25 Z M 9.164062 0.230469 C 9.476562 0.53125 9.480469 1.015625 9.175781 1.308594 L 4.535156 5.765625 C 4.230469 6.058594 3.726562 6.054688 3.414062 5.753906 C 3.101562 5.453125 3.09375 4.96875 3.398438 4.675781 L 8.039062 0.21875 C 8.34375 -0.0742188 8.851562 -0.0664062 9.164062 0.230469 Z M 15.761719 6.570312 C 16.074219 6.867188 16.078125 7.355469 15.773438 7.644531 L 11.132812 12.105469 C 10.828125 12.398438 10.324219 12.390625 10.011719 12.09375 C 9.699219 11.792969 9.691406 11.308594 9.996094 11.015625 L 14.640625 6.558594 C 14.945312 6.261719 15.449219 6.269531 15.761719 6.570312 Z M 15.761719 6.570312 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.2c33490daad4833a96d396e7bd52825b.svg";
export { ForwardRef as ReactComponent };